import { useTranslation } from "react-i18next";
import OrderModal, { ModalType } from "../OrderModal/OrderModal";

const DeleteLinesOrderModal = ({
  open,
  closeModal,
  primaryButtonClick,
}: ModalType) => {
  const { t } = useTranslation(["orders", "common"]);

  return (
    <>
      <OrderModal
        data-testid="delete-lines-order-modal"
        openModal={open}
        title={t("orders:modal.deleteOrderModal.title")}
        description={t("orders:modal.deleteOrderModal.description")}
        primaryButtonName={t("orders:orderLines.button.delete")}
        secondaryButtonName={t("common:modal.cancelBtn")}
        closeModalFn={closeModal}
        onPrimaryButtonClick={primaryButtonClick}
      />
    </>
  );
};

export default DeleteLinesOrderModal;
